import { render, staticRenderFns } from "./DialogAddCategory.vue?vue&type=template&id=b6868130&scoped=true"
import script from "./DialogAddCategory.vue?vue&type=script&lang=js"
export * from "./DialogAddCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6868130",
  null
  
)

export default component.exports